/* eslint-disable */
export const maxLifetime = 122

export default [
[ 0, 100000 ],
[ 1, 97074 ],
[ 5, 96014 ],
[ 10, 95540 ],
[ 15, 95174 ],
[ 20, 94666 ],
[ 25, 93989 ],
[ 30, 93243 ],
[ 35, 92379 ],
[ 40, 91298 ],
[ 45, 89963 ],
[ 50, 88203 ],
[ 55, 85659 ],
[ 60, 81892 ],
[ 65, 76421 ],
[ 70, 68643 ],
[ 75, 57878 ],
[ 80, 44221 ],
[ 85, 29066 ],
[ 90, 15285 ],
[ 95, 5857 ],
[ 100, 1471 ],
[ 105, 0 ]
]
